<template>
  <v-alert v-if="!arenaId" type="info">
    {{ $t('purchase.globalMessage') }}
  </v-alert>
  <div v-else-if="!areCurrenciesLoading" class="purchase-container">
    <div class="purchase-layout">
      <Catalog
        class="catalog-panel"
        :arena-currency="arenaCurrency"
        :is-arena-currency-loading="areCurrenciesLoading" />
      <Basket
        ref="basket"
        class="basket-panel"
        :arena-currency="arenaCurrency"
        :is-arena-currency-loading="areCurrenciesLoading"
        @reset-basket="handleResetBasket"
        @payment-success="handlePaymentSuccess" />
      <Customer
        ref="customer"
        class="customer-panel"
        @customer-selected="handleCustomerSelected" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Basket from './basket/index.vue'
import Catalog from './catalog/index.vue'
import Currency from '@/models/shop/Currency'
import Customer from './customer/index.vue'

export default {
  name: 'Purchase',
  components: {
    Basket,
    Catalog,
    Customer,
  },
  data: () => ({
    areCurrenciesLoading: false,
    currencies: [],
  }),
  computed: {
    ...mapGetters('cart', ['cartItems', 'cartId']),
    arenaCurrency() {
      const arenaCurrency = this.currencies[0]
      return arenaCurrency ?? null
    },
    arenaId() {
      return this.$store.getters.arena?.id
    },
  },
  methods: {
    async fetchCurrencies() {
      this.areCurrenciesLoading = true
      try {
        const response = await Currency.api.getArenaCurrencies(this.arenaId)
        const dataArray = response.data?.data ?? []
        this.currencies = dataArray.map((it) => new Currency(it))
      } catch (error) {
        console.error(error)
        this.currencies = []
      } finally {
        this.areCurrenciesLoading = false
      }
    },
    handleResetBasket() {
      // Reset user selection before resetting cart
      if (this.$refs.customer) {
        this.$refs.customer.resetCustomer()
      }
      if (this.$refs.basket) {
        this.$refs.basket.resetDiscount()
        this.$refs.basket.resetCart()
      }
      this.$store.dispatch('cart/resetCart')
    },
    handlePaymentSuccess() {
      if (this.$refs.customer) {
        this.$refs.customer.resetCustomer()
      }
    },
    async handleCustomerSelected(userId) {
      if (!userId && !this.cartId) return
      const payload = { buyer_user_id: userId ?? null }
      if (this.cartId) {
        await this.$refs.basket?.updateCart(payload)
      } else {
        await this.$refs.basket?.createCart({
          currency_id: this.arenaCurrency?.id,
          ...payload,
        })
      }
    },
  },
  async created() {
    await this.fetchCurrencies()
  },
}
</script>

<style scoped>
.purchase-container {
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  margin-top: -3rem;
  margin-bottom: -3rem;
  padding: 0 0.75rem;
  box-sizing: border-box;
}

.purchase-layout {
  display: grid;
  grid-template-columns: 34fr 46fr 20fr;
  grid-template-rows: 1fr;
  gap: 1rem;
  width: 100%;
  height: 88dvh;
  min-height: 88dvh;
  box-sizing: border-box;
}

.purchase-layout > * {
  height: 100%;
}
</style>
